import {
  Search, Bot, MousePointerClick, Target, Linkedin, Mail,
  TrendingUp, Sparkles, LineChart, MonitorSmartphone,
} from "lucide-react";

const services = [
  { icon: MonitorSmartphone, title: "Website Design & Landing Pages", desc: "We design modern, mobile-friendly and conversion-focused websites and landing pages that help businesses generate enquiries, collect leads and build trust online." },
  { icon: Search, title: "SEO Services", desc: "Rank higher on Google with technical, on-page and off-page SEO built for long-term compounding traffic." },
  { icon: Bot, title: "AEO & GEO Optimization", desc: "Get discovered by AI answer engines and generative search results like ChatGPT, Gemini and Google AI Overviews." },
  { icon: MousePointerClick, title: "Google Ads Management", desc: "High-intent search, shopping and PMax campaigns that drive qualified clicks and lower cost per lead." },
  { icon: Target, title: "Meta Ads Management", desc: "Facebook and Instagram advertising with sharp creatives, precise targeting and full-funnel optimization." },
  { icon: Linkedin, title: "LinkedIn Marketing", desc: "B2B lead generation and personal brand growth using organic content, outreach and paid campaigns." },
  { icon: Mail, title: "Email Marketing", desc: "Newsletters, drip campaigns and lifecycle flows that nurture leads and drive repeat revenue." },
  { icon: TrendingUp, title: "Performance Marketing", desc: "Data-driven paid media across channels with clear ROAS, CAC and pipeline attribution." },
  { icon: Sparkles, title: "AI Marketing Automation", desc: "Automate lead follow-ups, reports, CRM workflows and content operations with AI-powered systems." },
  { icon: LineChart, title: "Analytics & Reporting", desc: "Clear dashboards with GA4, GSC and paid media data so you always know what's working." },
];

export default function Services() {
  return (
    <section id="services" className="bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-600">Services</div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
            Everything you need to grow — under one roof.
          </h2>
          <p className="mt-4 text-slate-600 text-base md:text-lg leading-relaxed">
            A full-stack growth partner across SEO, paid ads, content and AI automation.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-card-${i}`}
              className="reveal group bg-white border border-slate-200 rounded-3xl p-7 hover:shadow-xl hover:border-blue-200 transition-all"
            >
              <div className="w-12 h-12 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-colors">
                <s.icon className="w-6 h-6" />
              </div>
              <h3 className="mt-5 font-display font-bold text-slate-900 text-lg">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
